(function(a) {
    a.fn.prepareTransition = function() {
        return this.each(function() {
            var b = a(this);
            b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                b.removeClass("is-transitioning")
            });
            var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
            var d = 0;
            a.each(c, function(a, c) {
                d = parseFloat(b.css(c)) || d
            });
            if (d != 0) {
                b.addClass("is-transitioning");
                b[0].offsetWidth
            }
        })
    }
})(jQuery);

function replaceUrlParam(e, r, a) {
    var n = new RegExp("(" + r + "=).*?(&|$)"),
        c = e;
    return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};
if ((typeof Shopify) === 'undefined') {
    Shopify = {}
}
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || this.money_format);
        if (typeof cents == 'string') {
            cents = cents.replace('.', '')
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt)
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            if (isNaN(number) || number == null) {
                return 0
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break
        }
        return formatString.replace(placeholderRegex, value)
    }
}
window.timber = window.timber || {};
timber.cacheSelectors = function() {
    timber.cache = {
        $html: $('html'),
        $body: $(document.body),
        $navigation: $('#AccessibleNav'),
        $mobileSubNavToggle: $('.mobile-nav__toggle'),
        $mobileNavLink: $('.mobile-nav__link'),
        $changeView: $('.change-view'),
        $productImage: $('#ProductPhotoImg'),
        $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),
        $thumbImages2: $('#ProductThumbs2').find('a.product-single__thumbnail'),
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess')
    }
};
timber.init = function() {
    FastClick.attach(document.body);
    timber.cacheSelectors();
    timber.accessibleNav();
    timber.drawersInit();
    timber.mobileNavToggle();
    timber.productImageSwitch();
    timber.productImageSwitch2();
    timber.responsiveVideos();
    timber.collectionViews();
    timber.loginForms()
};
timber.accessibleNav = function() {
    var $nav = timber.cache.$navigation,
        $allLinks = $nav.find('a'),
        $topLevel = $nav.children('li').find('a'),
        $parents = $nav.find('.site-nav--has-dropdown'),
        $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
        activeClass = 'nav-hover',
        focusClass = 'nav-focus';
    $parents.on('mouseenter touchstart', function(evt) {
        var $el = $(this);
        if (!$el.hasClass(activeClass)) {
            evt.preventDefault()
        }
        showDropdown($el)
    });
    $parents.on('mouseleave', function() {
        hideDropdown($(this))
    });
    $subMenuLinks.on('touchstart', function(evt) {
        evt.stopImmediatePropagation()
    });
    $allLinks.focus(function() {
        handleFocus($(this))
    });
    $allLinks.blur(function() {
        removeFocus($topLevel)
    });

    function handleFocus($el) {
        var $subMenu = $el.next('ul'),
            hasSubMenu = $subMenu.hasClass('sub-nav') ? !0 : !1,
            isSubItem = $('.site-nav__dropdown').has($el).length,
            $newFocus = null;
        if (!isSubItem) {
            removeFocus($topLevel);
            addFocus($el)
        } else {
            $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
            addFocus($newFocus)
        }
    }

    function showDropdown($el) {
        $el.addClass(activeClass);
        setTimeout(function() {
            timber.cache.$body.on('touchstart', function() {
                hideDropdown($el)
            })
        }, 250)
    }

    function hideDropdown($el) {
        $el.removeClass(activeClass);
        timber.cache.$body.off('touchstart')
    }

    function addFocus($el) {
        $el.addClass(focusClass)
    }

    function removeFocus($el) {
        $el.removeClass(focusClass)
    }
};
timber.drawersInit = function() {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
    })
};
timber.mobileNavToggle = function() {
    timber.cache.$mobileSubNavToggle.on('click', function() {
        $(this).parent().toggleClass('mobile-nav--expanded')
    });
    timber.cache.$mobileNavLink.on('click', function() {
        $(this).parent().toggleClass('mobile-nav--expanded')
    })
};
timber.getHash = function() {
    return window.location.hash
};
timber.productPage = function(options) {
    var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector;
    var $productImage = $('#ProductPhotoImg'),
        $addToCart = $('#AddToCart'),
        $productPrice = $('#ProductPrice'),
        $comparePrice = $('#ComparePrice'),
        $quantityElements = $('.quantity-selector, label + .js-qty'),
        $addToCartText = $('#AddToCartText');
    
    if (variant) {
        var form = jQuery('#' + selector.domIdPrefix).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
           var productPersoanlize = form.find('#personalizeText')
          if(productPersoanlize.length > 0) {
            var varr = form.find('input:checked').data('text')
            if(variant.title === 'Upload Photo') {
              varr = ''
            }
            var length = varr.length
            if(length > 0) {
              productPersoanlize.find('input').attr('maxLength', length)
              productPersoanlize.find('input').val(varr)
            } else {
              productPersoanlize.find('input').attr('maxLength', '')
              productPersoanlize.find('input').val('-')
            }
          }
          if (radioButton.length > 0) {
                radioButton.get(0).checked = !0
            }
            if (variant.compare_at_price > variant.price) {
              var discountElement = document.getElementById('newDiscount');
              if(discountElement) {
                var newDiscount = Math.round((1 - (variant.price / variant.compare_at_price)) * 100);
                newDiscount = '(' + newDiscount + '%)';
                discountElement.textContent = newDiscount;
              }
            }
        }
        if (variant.featured_image) {
            var newImg = variant.featured_image,
                el = $productImage[0];
            Shopify.Image.switchImage(newImg, el, timber.switchImage);

            // Navigate mobile swiper to the variant's featured image by matching base filename
            if (window.galleryMobileSwiper) {
                var shopifyImgSizePattern = /_(?:\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.[a-z]+)$/i;
                function getImgBase(url) {
                    if (!url) return '';
                    return (url + '').split('?')[0].split('/').pop()
                        .replace(shopifyImgSizePattern, '$1').toLowerCase();
                }
                var variantBase = getImgBase(variant.featured_image.src);
                var targetIndex = -1;
                $('.gallery-mobile .swiper-slide').each(function(i) {
                    var src = $(this).find('img').data('src') || $(this).find('img').attr('src') || '';
                    if (variantBase && getImgBase(src) === variantBase) {
                        targetIndex = i;
                        return false;
                    }
                });
                if (targetIndex >= 0) {
                    window.galleryMobileSwiper.slideTo(targetIndex);
                } else if (variant.featured_image.position) {
                    // Fallback: position-based matching
                    var $targetSlide = $('.gallery-mobile .swiper-slide[data-position="' + variant.featured_image.position + '"]');
                    if ($targetSlide.length) {
                        window.galleryMobileSwiper.slideTo($targetSlide.index());
                    }
                }
            }
        }
        if (variant.available) {
            $addToCart.removeClass('disabled').prop('disabled', !1);
            $addToCartText.html("Buy Now");
            $quantityElements.show()
        } else {
            $addToCart.addClass('disabled').prop('disabled', !0);
            $addToCartText.html("Sold Out");
            $quantityElements.hide()
        }
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show()
        } else {
            $comparePrice.hide()
        }
      $("#flower-step").removeClass("disabled")
    } else {
        $addToCart.addClass('disabled').prop('disabled', !0);
        $addToCartText.html("Produk Tidak Tersedia");
        $quantityElements.hide()
        $("#flower-step").addClass("disabled")
    }
    var price1 = parseInt($("#product-price-ori").attr("content"));
    var price2 = parseInt($("#product-price-bundl").attr("content"));
    var price3 = price1 + price2;
    $(".hasil").html(Shopify.formatMoney(price3, moneyFormat))
};
timber.productImageSwitch = function() {
    if (timber.cache.$thumbImages.length) {
        timber.cache.$thumbImages.on('click', function(evt) {
            evt.preventDefault();
            var newImage = $(this).attr('data-standard');
            timber.switchImage(newImage, null, timber.cache.$productImage)
        })
    }
};
timber.productImageSwitch2 = function() {
    if (timber.cache.$thumbImages2.length) {
        timber.cache.$thumbImages2.on('click', function(evt) {
            evt.preventDefault();
            var newImage = $(this).attr('data-standard');
            timber.switchImage(newImage, null, timber.cache.$productImage)
        })
    }
};
timber.switchImage = function(src, imgObject, el) {
    var $el = $(el);
    $el.attr('src', src)
};
timber.responsiveVideos = function() {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
    $iframeVideo.each(function() {
        $(this).wrap('<div class="video-wrapper"></div>')
    });
    $iframeReset.each(function() {
        this.src = this.src
    })
};
timber.collectionViews = function() {
    if (timber.cache.$changeView.length) {
        timber.cache.$changeView.on('click', function() {
            var view = $(this).data('view'),
                url = document.URL,
                hasParams = url.indexOf('?') > -1;
            if (hasParams) {
                window.location = replaceUrlParam(url, 'view', view)
            } else {
                window.location = url + '?view=' + view
            }
        })
    }
};
timber.loginForms = function() {
    function showRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.show();
        timber.cache.$customerLoginForm.hide()
    }

    function hideRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.hide();
        timber.cache.$customerLoginForm.show()
    }
    timber.cache.$recoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm()
    });
    timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm()
    });
    if (timber.getHash() == '#recover') {
        showRecoverPasswordForm()
    }
};
timber.resetPasswordSuccess = function() {
    timber.cache.$passwordResetSuccess.show()
};
timber.Drawers = (function() {
    var Drawer = function(id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };
        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            moved: $('.is-moved-by-drawer')
        };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $('#' + id);
        if (!this.$drawer.length) {
            return !1
        }
        this.drawerIsOpen = !1;
        this.init()
    };
    Drawer.prototype.init = function() {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this))
    };
    Drawer.prototype.open = function(evt) {
        var externalCall = !1;
        if (evt) {
            evt.preventDefault()
        } else {
            externalCall = !0
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget)
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close()
        }
        timber.cache.$body.trigger('beforeDrawerOpen.timber', this);
        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();
        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = !0;
        this.trapFocus(this.$drawer, 'drawer_focus');
        if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
            if (!externalCall) {
                this.config.onDrawerOpen()
            }
        }
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true')
        }
        this.$nodes.page.on('touchmove.drawer', function() {
            return !1
        });
        this.$nodes.page.on('click.drawer', $.proxy(function() {
            this.close();
            return !1
        }, this));
        timber.cache.$body.trigger('afterDrawerOpen.timber', this)
    };
    Drawer.prototype.close = function() {
        if (!this.drawerIsOpen) {
            return
        }
        timber.cache.$body.trigger('beforeDrawerClose.timber', this);
        $(document.activeElement).trigger('blur');
        this.$nodes.moved.prepareTransition({
            disableExisting: !0
        });
        this.$drawer.prepareTransition({
            disableExisting: !0
        });
        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
        this.drawerIsOpen = !1;
        this.removeTrapFocus(this.$drawer, 'drawer_focus');
        this.$nodes.page.off('.drawer');
        timber.cache.$body.trigger('afterDrawerClose.timber', this)
    };
    Drawer.prototype.trapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.attr('tabindex', '-1');
        $container.focus();
        $(document).on(eventName, function(evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus()
            }
        })
    };
    Drawer.prototype.removeTrapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.removeAttr('tabindex');
        $(document).off(eventName)
    };
    return Drawer
})();
$(timber.init);

/*!* @name EasyZoom* @author Matt Hinchliffe <> * @modified    Monday, April 18th, 2016 * @version 2.4.0 */
! function(a) {
    "use strict";

    function b(b, c) {
        this.$target = a(b), this.opts = a.extend({}, i, c, this.$target.data()), void 0 === this.isOpen && this._init()
    }
    var c, d, e, f, g, h, i = {
        loadingNotice: "...",
        errorNotice: "The image could not be loaded",
        errorDuration: 2500,
        linkAttribute: "href",
        preventClicks: !0,
        beforeShow: a.noop,
        beforeHide: a.noop,
        onShow: a.noop,
        onHide: a.noop,
        onMove: a.noop
    };
    b.prototype._init = function() {
        this.$link = this.$target.find("a"), this.$image = this.$target.find("img"), this.$flyout = a('<div class="easyzoom-flyout" />'), this.$notice = a('<div class="easyzoom-notice" />'), this.$target.on({
            "mousemove.easyzoom touchmove.easyzoom": a.proxy(this._onMove, this),
            "mouseleave.easyzoom touchend.easyzoom": a.proxy(this._onLeave, this),
            "mouseenter.easyzoom touchstart.easyzoom": a.proxy(this._onEnter, this)
        }), this.opts.preventClicks && this.$target.on("click.easyzoom", function(a) {
            a.preventDefault()
        })
    }, b.prototype.show = function(a, b) {
        var g, h, i, j, k = this;
        if (this.opts.beforeShow.call(this) !== !1) {
            if (!this.isReady) return this._loadImage(this.$link.attr(this.opts.linkAttribute), function() {
                (k.isMouseOver || !b) && k.show(a)
            });
            this.$target.append(this.$flyout), g = this.$target.width(), h = this.$target.height(), i = this.$flyout.width(), j = this.$flyout.height(), c = this.$zoom.width() - i, d = this.$zoom.height() - j, e = c / g, f = d / h, this.isOpen = !0, this.opts.onShow.call(this), a && this._move(a)
        }
    }, b.prototype._onEnter = function(a) {
        var b = a.originalEvent.touches;
        this.isMouseOver = !0, b && 1 != b.length || (a.preventDefault(), this.show(a, !0))
    }, b.prototype._onMove = function(a) {
        this.isOpen && (a.preventDefault(), this._move(a))
    }, b.prototype._onLeave = function() {
        this.isMouseOver = !1, this.isOpen && this.hide()
    }, b.prototype._onLoad = function(a) {
        a.currentTarget.width && (this.isReady = !0, this.$notice.detach(), this.$flyout.html(this.$zoom), this.$target.removeClass("is-loading").addClass("is-ready"), a.data.call && a.data())
    }, b.prototype._onError = function() {
        var a = this;
        this.$notice.text(this.opts.errorNotice), this.$target.removeClass("is-loading").addClass("is-error"), this.detachNotice = setTimeout(function() {
            a.$notice.detach(), a.detachNotice = null
        }, this.opts.errorDuration)
    }, b.prototype._loadImage = function(b, c) {
        var d = new Image;
        this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)), this.$zoom = a(d).on("error", a.proxy(this._onError, this)).on("load", c, a.proxy(this._onLoad, this)), d.style.position = "absolute", d.src = b
    }, b.prototype._move = function(a) {
        if (0 === a.type.indexOf("touch")) {
            var b = a.touches || a.originalEvent.touches;
            g = b[0].pageX, h = b[0].pageY
        } else g = a.pageX || g, h = a.pageY || h;
        var i = this.$target.offset(),
            j = h - i.top,
            k = g - i.left,
            l = Math.ceil(j * f),
            m = Math.ceil(k * e);
        if (0 > m || 0 > l || m > c || l > d) this.hide();
        else {
            var n = -1 * l,
                o = -1 * m;
            this.$zoom.css({
                top: n,
                left: o
            }), this.opts.onMove.call(this, n, o)
        }
    }, b.prototype.hide = function() {
        this.isOpen && this.opts.beforeHide.call(this) !== !1 && (this.$flyout.detach(), this.isOpen = !1, this.opts.onHide.call(this))
    }, b.prototype.swap = function(b, c, d) {
        this.hide(), this.isReady = !1, this.detachNotice && clearTimeout(this.detachNotice), this.$notice.parent().length && this.$notice.detach(), this.$target.removeClass("is-loading is-ready is-error"), this.$image.attr({
            src: b,
            srcset: a.isArray(d) ? d.join() : d
        }), this.$link.attr(this.opts.linkAttribute, c)
    }, b.prototype.teardown = function() {
        this.hide(), this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"), this.detachNotice && clearTimeout(this.detachNotice), delete this.$link, delete this.$zoom, delete this.$image, delete this.$notice, delete this.$flyout, delete this.isOpen, delete this.isReady
    }, a.fn.easyZoom = function(c) {
        return this.each(function() {
            var d = a.data(this, "easyZoom");
            d ? void 0 === d.isOpen && d._init() : a.data(this, "easyZoom", new b(this, c))
        })
    }, "function" == typeof define && define.amd ? define(function() {
        return b
    }) : "undefined" != typeof module && module.exports && (module.exports = b)
}(jQuery);

if (!jQuery) throw new Error("Bootstrap requires jQuery"); + function(t) {
    "use strict";

    function e() {
        var t = document.createElement("bootstrap"),
            e = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            };
        for (var n in e)
            if (void 0 !== t.style[n]) return {
                end: e[n]
            }
    }
    t.fn.emulateTransitionEnd = function(e) {
        var n = !1,
            i = this;
        t(this).one(t.support.transition.end, function() {
            n = !0
        });
        var o = function() {
            n || t(i).trigger(t.support.transition.end)
        };
        return setTimeout(o, e), this
    }, t(function() {
        t.support.transition = e()
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = '[data-dismiss="alert"]',
        n = function(n) {
            t(n).on("click", e, this.close)
        };
    n.prototype.close = function(e) {
        function n() {
            s.trigger("closed.bs.alert").remove()
        }
        var i = t(this),
            o = i.attr("data-target");
        o || (o = i.attr("href"), o = o && o.replace(/.*(?=#[^\s]*$)/, ""));
        var s = t(o);
        e && e.preventDefault(), s.length || (s = i.hasClass("alert") ? i : i.parent()), s.trigger(e = t.Event("close.bs.alert")), e.isDefaultPrevented() || (s.removeClass("in"), t.support.transition && s.hasClass("fade") ? s.one(t.support.transition.end, n).emulateTransitionEnd(150) : n())
    };
    var i = t.fn.alert;
    t.fn.alert = function(e) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.alert");
            o || i.data("bs.alert", o = new n(this)), "string" == typeof e && o[e].call(i)
        })
    }, t.fn.alert.Constructor = n, t.fn.alert.noConflict = function() {
        return t.fn.alert = i, this
    }, t(document).on("click.bs.alert.data-api", e, n.prototype.close)
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.$element = t(n), this.options = t.extend({}, e.DEFAULTS, i)
    };
    e.DEFAULTS = {
        loadingText: "loading..."
    }, e.prototype.setState = function(t) {
        var e = "disabled",
            n = this.$element,
            i = n.is("input") ? "val" : "html",
            o = n.data();
        t += "Text", o.resetText || n.data("resetText", n[i]()), n[i](o[t] || this.options[t]), setTimeout(function() {
            "loadingText" == t ? n.addClass(e).attr(e, e) : n.removeClass(e).removeAttr(e)
        }, 0)
    }, e.prototype.toggle = function() {
        var t = this.$element.closest('[data-toggle="buttons"]');
        if (t.length) {
            "radio" === this.$element.find("input").prop("checked", !this.$element.hasClass("active")).trigger("change").prop("type") && t.find(".active").removeClass("active")
        }
        this.$element.toggleClass("active")
    };
    var n = t.fn.button;
    t.fn.button = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.button"),
                s = "object" == typeof n && n;
            o || i.data("bs.button", o = new e(this, s)), "toggle" == n ? o.toggle() : n && o.setState(n)
        })
    }, t.fn.button.Constructor = e, t.fn.button.noConflict = function() {
        return t.fn.button = n, this
    }, t(document).on("click.bs.button.data-api", "[data-toggle^=button]", function(e) {
        var n = t(e.target);
        n.hasClass("btn") || (n = n.closest(".btn")), n.button("toggle"), e.preventDefault()
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e, n) {
        this.$element = t(e), this.$indicators = this.$element.find(".carousel-indicators"), this.options = n, this.paused = this.sliding = this.interval = this.$active = this.$items = null, "hover" == this.options.pause && this.$element.on("mouseenter", t.proxy(this.pause, this)).on("mouseleave", t.proxy(this.cycle, this))
    };
    e.DEFAULTS = {
        interval: 5e3,
        pause: "hover",
        wrap: !0
    }, e.prototype.cycle = function(e) {
        return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(t.proxy(this.next, this), this.options.interval)), this
    }, e.prototype.getActiveIndex = function() {
        return this.$active = this.$element.find(".item.active"), this.$items = this.$active.parent().children(), this.$items.index(this.$active)
    }, e.prototype.to = function(e) {
        var n = this,
            i = this.getActiveIndex();
        return e > this.$items.length - 1 || 0 > e ? void 0 : this.sliding ? this.$element.one("slid", function() {
            n.to(e)
        }) : i == e ? this.pause().cycle() : this.slide(e > i ? "next" : "prev", t(this.$items[e]))
    }, e.prototype.pause = function(e) {
        return e || (this.paused = !0), this.$element.find(".next, .prev").length && t.support.transition.end && (this.$element.trigger(t.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
    }, e.prototype.next = function() {
        return this.sliding ? void 0 : this.slide("next")
    }, e.prototype.prev = function() {
        return this.sliding ? void 0 : this.slide("prev")
    }, e.prototype.slide = function(e, n) {
        var i = this.$element.find(".item.active"),
            o = n || i[e](),
            s = this.interval,
            r = "next" == e ? "left" : "right",
            a = "next" == e ? "first" : "last",
            l = this;
        if (!o.length) {
            if (!this.options.wrap) return;
            o = this.$element.find(".item")[a]()
        }
        this.sliding = !0, s && this.pause();
        var c = t.Event("slide.bs.carousel", {
            relatedTarget: o[0],
            direction: r
        });
        if (!o.hasClass("active")) {
            if (this.$indicators.length && (this.$indicators.find(".active").removeClass("active"), this.$element.one("slid", function() {
                    var e = t(l.$indicators.children()[l.getActiveIndex()]);
                    e && e.addClass("active")
                })), t.support.transition && this.$element.hasClass("slide")) {
                if (this.$element.trigger(c), c.isDefaultPrevented()) return;
                o.addClass(e), o[0].offsetWidth, i.addClass(r), o.addClass(r), i.one(t.support.transition.end, function() {
                    o.removeClass([e, r].join(" ")).addClass("active"), i.removeClass(["active", r].join(" ")), l.sliding = !1, setTimeout(function() {
                        l.$element.trigger("slid")
                    }, 0)
                }).emulateTransitionEnd(600)
            } else {
                if (this.$element.trigger(c), c.isDefaultPrevented()) return;
                i.removeClass("active"), o.addClass("active"), this.sliding = !1, this.$element.trigger("slid")
            }
            return s && this.cycle(), this
        }
    };
    var n = t.fn.carousel;
    t.fn.carousel = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.carousel"),
                s = t.extend({}, e.DEFAULTS, i.data(), "object" == typeof n && n),
                r = "string" == typeof n ? n : s.slide;
            o || i.data("bs.carousel", o = new e(this, s)), "number" == typeof n ? o.to(n) : r ? o[r]() : s.interval && o.pause().cycle()
        })
    }, t.fn.carousel.Constructor = e, t.fn.carousel.noConflict = function() {
        return t.fn.carousel = n, this
    }, t(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", function(e) {
        var n, i = t(this),
            o = t(i.attr("data-target") || (n = i.attr("href")) && n.replace(/.*(?=#[^\s]+$)/, "")),
            s = t.extend({}, o.data(), i.data()),
            r = i.attr("data-slide-to");
        r && (s.interval = !1), o.carousel(s), (r = i.attr("data-slide-to")) && o.data("bs.carousel").to(r), e.preventDefault()
    }), t(window).on("load", function() {
        t('[data-ride="carousel"]').each(function() {
            var e = t(this);
            e.carousel(e.data())
        })
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.$element = t(n), this.options = t.extend({}, e.DEFAULTS, i), this.transitioning = null, this.options.parent && (this.$parent = t(this.options.parent)), this.options.toggle && this.toggle()
    };
    e.DEFAULTS = {
        toggle: !0
    }, e.prototype.dimension = function() {
        return this.$element.hasClass("width") ? "width" : "height"
    }, e.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var e = t.Event("show.bs.collapse");
            if (this.$element.trigger(e), !e.isDefaultPrevented()) {
                var n = this.$parent && this.$parent.find("> .panel > .in");
                if (n && n.length) {
                    var i = n.data("bs.collapse");
                    if (i && i.transitioning) return;
                    n.collapse("hide"), i || n.data("bs.collapse", null)
                }
                var o = this.dimension();
                this.$element.removeClass("collapse").addClass("collapsing")[o](0), this.transitioning = 1;
                var s = function() {
                    this.$element.removeClass("collapsing").addClass("in")[o]("auto"), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
                };
                if (!t.support.transition) return s.call(this);
                var r = t.camelCase(["scroll", o].join("-"));
                this.$element.one(t.support.transition.end, t.proxy(s, this)).emulateTransitionEnd(350)[o](this.$element[0][r])
            }
        }
    }, e.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var e = t.Event("hide.bs.collapse");
            if (this.$element.trigger(e), !e.isDefaultPrevented()) {
                var n = this.dimension();
                this.$element[n](this.$element[n]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse").removeClass("in"), this.transitioning = 1;
                var i = function() {
                    this.transitioning = 0, this.$element.trigger("hidden.bs.collapse").removeClass("collapsing").addClass("collapse")
                };
                return t.support.transition ? void this.$element[n](0).one(t.support.transition.end, t.proxy(i, this)).emulateTransitionEnd(350) : i.call(this)
            }
        }
    }, e.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]()
    };
    var n = t.fn.collapse;
    t.fn.collapse = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.collapse"),
                s = t.extend({}, e.DEFAULTS, i.data(), "object" == typeof n && n);
            o || i.data("bs.collapse", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.collapse.Constructor = e, t.fn.collapse.noConflict = function() {
        return t.fn.collapse = n, this
    }, t(document).on("click.bs.collapse.data-api", "[data-toggle=collapse]", function(e) {
        var n, i = t(this),
            o = i.attr("data-target") || e.preventDefault() || (n = i.attr("href")) && n.replace(/.*(?=#[^\s]+$)/, ""),
            s = t(o),
            r = s.data("bs.collapse"),
            a = r ? "toggle" : i.data(),
            l = i.attr("data-parent"),
            c = l && t(l);
        r && r.transitioning || (c && c.find('[data-toggle=collapse][data-parent="' + l + '"]').not(i).addClass("collapsed"), i[s.hasClass("in") ? "addClass" : "removeClass"]("collapsed")), s.collapse(a)
    })
}(window.jQuery),
function(t) {
    "use strict";

    function e() {
        t(i).remove(), t(o).each(function(e) {
            var i = n(t(this));
            i.hasClass("open") && (i.trigger(e = t.Event("hide.bs.dropdown")), e.isDefaultPrevented() || i.removeClass("open").trigger("hidden.bs.dropdown"))
        })
    }

    function n(e) {
        var n = e.attr("data-target");
        n || (n = e.attr("href"), n = n && /#/.test(n) && n.replace(/.*(?=#[^\s]*$)/, ""));
        var i = n && t(n);
        return i && i.length ? i : e.parent()
    }
    var i = ".dropdown-backdrop",
        o = "[data-toggle=dropdown]",
        s = function(e) {
            t(e).on("click.bs.dropdown", this.toggle)
        };
    s.prototype.toggle = function(i) {
        var o = t(this);
        if (!o.is(".disabled, :disabled")) {
            var s = n(o),
                r = s.hasClass("open");
            if (e(), !r) {
                if ("ontouchstart" in document.documentElement && !s.closest(".navbar-nav").length && t('<div class="dropdown-backdrop"/>').insertAfter(t(this)).on("click", e), s.trigger(i = t.Event("show.bs.dropdown")), i.isDefaultPrevented()) return;
                s.toggleClass("open").trigger("shown.bs.dropdown"), o.focus()
            }
            return !1
        }
    }, s.prototype.keydown = function(e) {
        if (/(38|40|27)/.test(e.keyCode)) {
            var i = t(this);
            if (e.preventDefault(), e.stopPropagation(), !i.is(".disabled, :disabled")) {
                var s = n(i),
                    r = s.hasClass("open");
                if (!r || r && 27 == e.keyCode) return 27 == e.which && s.find(o).focus(), i.click();
                var a = t("[role=menu] li:not(.divider):visible a", s);
                if (a.length) {
                    var l = a.index(a.filter(":focus"));
                    38 == e.keyCode && l > 0 && l--, 40 == e.keyCode && l < a.length - 1 && l++, ~l || (l = 0), a.eq(l).focus()
                }
            }
        }
    };
    var r = t.fn.dropdown;
    t.fn.dropdown = function(e) {
        return this.each(function() {
            var n = t(this),
                i = n.data("dropdown");
            i || n.data("dropdown", i = new s(this)), "string" == typeof e && i[e].call(n)
        })
    }, t.fn.dropdown.Constructor = s, t.fn.dropdown.noConflict = function() {
        return t.fn.dropdown = r, this
    }, t(document).on("click.bs.dropdown.data-api", e).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
        t.stopPropagation()
    }).on("click.bs.dropdown.data-api", o, s.prototype.toggle).on("keydown.bs.dropdown.data-api", o + ", [role=menu]", s.prototype.keydown)
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e, n) {
        this.options = n, this.$element = t(e), this.$backdrop = this.isShown = null, this.options.remote && this.$element.load(this.options.remote)
    };
    e.DEFAULTS = {
        backdrop: !0,
        keyboard: !0,
        show: !0
    }, e.prototype.toggle = function(t) {
        return this[this.isShown ? "hide" : "show"](t)
    }, e.prototype.show = function(e) {
        var n = this,
            i = t.Event("show.bs.modal", {
                relatedTarget: e
            });
        this.$element.trigger(i), this.isShown || i.isDefaultPrevented() || (this.isShown = !0, this.escape(), this.$element.on("click.dismiss.modal", '[data-dismiss="modal"]', t.proxy(this.hide, this)), this.backdrop(function() {
            var i = t.support.transition && n.$element.hasClass("fade");
            n.$element.parent().length || n.$element.appendTo(document.body), n.$element.show(), i && n.$element[0].offsetWidth, n.$element.addClass("in").attr("aria-hidden", !1), n.enforceFocus();
            var o = t.Event("shown.bs.modal", {
                relatedTarget: e
            });
            i ? n.$element.find(".modal-dialog").one(t.support.transition.end, function() {
                n.$element.focus().trigger(o)
            }).emulateTransitionEnd(300) : n.$element.focus().trigger(o)
        }))
    }, e.prototype.hide = function(e) {
        e && e.preventDefault(), e = t.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), t(document).off("focusin.bs.modal"), this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.modal"), t.support.transition && this.$element.hasClass("fade") ? this.$element.one(t.support.transition.end, t.proxy(this.hideModal, this)).emulateTransitionEnd(300) : this.hideModal())
    }, e.prototype.enforceFocus = function() {
        t(document).off("focusin.bs.modal").on("focusin.bs.modal", t.proxy(function(t) {
            this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.focus()
        }, this))
    }, e.prototype.escape = function() {
        this.isShown && this.options.keyboard ? this.$element.on("keyup.dismiss.bs.modal", t.proxy(function(t) {
            27 == t.which && this.hide()
        }, this)) : this.isShown || this.$element.off("keyup.dismiss.bs.modal")
    }, e.prototype.hideModal = function() {
        var t = this;
        this.$element.hide(), this.backdrop(function() {
            t.removeBackdrop(), t.$element.trigger("hidden.bs.modal")
        })
    }, e.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
    }, e.prototype.backdrop = function(e) {
        var n = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var i = t.support.transition && n;
            if (this.$backdrop = t('<div class="modal-backdrop ' + n + '" />').appendTo(document.body), this.$element.on("click.dismiss.modal", t.proxy(function(t) {
                    t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus.call(this.$element[0]) : this.hide.call(this))
                }, this)), i && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !e) return;
            i ? this.$backdrop.one(t.support.transition.end, e).emulateTransitionEnd(150) : e()
        } else !this.isShown && this.$backdrop ? (this.$backdrop.removeClass("in"), t.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one(t.support.transition.end, e).emulateTransitionEnd(150) : e()) : e && e()
    };
    var n = t.fn.modal;
    t.fn.modal = function(n, i) {
        return this.each(function() {
            var o = t(this),
                s = o.data("bs.modal"),
                r = t.extend({}, e.DEFAULTS, o.data(), "object" == typeof n && n);
            s || o.data("bs.modal", s = new e(this, r)), "string" == typeof n ? s[n](i) : r.show && s.show(i)
        })
    }, t.fn.modal.Constructor = e, t.fn.modal.noConflict = function() {
        return t.fn.modal = n, this
    }, t(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e) {
        var n = t(this),
            i = n.attr("href"),
            o = t(n.attr("data-target") || i && i.replace(/.*(?=#[^\s]+$)/, "")),
            s = o.data("modal") ? "toggle" : t.extend({
                remote: !/#/.test(i) && i
            }, o.data(), n.data());
        e.preventDefault(), o.modal(s, this).one("hide", function() {
            n.is(":visible") && n.focus()
        })
    }), t(document).on("show.bs.modal", ".modal", function() {
        t(document.body).addClass("modal-open")
    }).on("hidden.bs.modal", ".modal", function() {
        t(document.body).removeClass("modal-open")
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(t, e) {
        this.type = this.options = this.enabled = this.timeout = this.hoverState = this.$element = null, this.init("tooltip", t, e)
    };
    e.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1
    }, e.prototype.init = function(e, n, i) {
        this.enabled = !0, this.type = e, this.$element = t(n), this.options = this.getOptions(i);
        for (var o = this.options.trigger.split(" "), s = o.length; s--;) {
            var r = o[s];
            if ("click" == r) this.$element.on("click." + this.type, this.options.selector, t.proxy(this.toggle, this));
            else if ("manual" != r) {
                var a = "hover" == r ? "mouseenter" : "focus",
                    l = "hover" == r ? "mouseleave" : "blur";
                this.$element.on(a + "." + this.type, this.options.selector, t.proxy(this.enter, this)), this.$element.on(l + "." + this.type, this.options.selector, t.proxy(this.leave, this))
            }
        }
        this.options.selector ? this._options = t.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle()
    }, e.prototype.getDefaults = function() {
        return e.DEFAULTS
    }, e.prototype.getOptions = function(e) {
        return e = t.extend({}, this.getDefaults(), this.$element.data(), e), e.delay && "number" == typeof e.delay && (e.delay = {
            show: e.delay,
            hide: e.delay
        }), e
    }, e.prototype.getDelegateOptions = function() {
        var e = {},
            n = this.getDefaults();
        return this._options && t.each(this._options, function(t, i) {
            n[t] != i && (e[t] = i)
        }), e
    }, e.prototype.enter = function(e) {
        var n = e instanceof this.constructor ? e : t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);
        return clearTimeout(n.timeout), n.hoverState = "in", n.options.delay && n.options.delay.show ? void(n.timeout = setTimeout(function() {
            "in" == n.hoverState && n.show()
        }, n.options.delay.show)) : n.show()
    }, e.prototype.leave = function(e) {
        var n = e instanceof this.constructor ? e : t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);
        return clearTimeout(n.timeout), n.hoverState = "out", n.options.delay && n.options.delay.hide ? void(n.timeout = setTimeout(function() {
            "out" == n.hoverState && n.hide()
        }, n.options.delay.hide)) : n.hide()
    }, e.prototype.show = function() {
        var e = t.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            if (this.$element.trigger(e), e.isDefaultPrevented()) return;
            var n = this.tip();
            this.setContent(), this.options.animation && n.addClass("fade");
            var i = "function" == typeof this.options.placement ? this.options.placement.call(this, n[0], this.$element[0]) : this.options.placement,
                o = /\s?auto?\s?/i,
                s = o.test(i);
            s && (i = i.replace(o, "") || "top"), n.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(i), this.options.container ? n.appendTo(this.options.container) : n.insertAfter(this.$element);
            var r = this.getPosition(),
                a = n[0].offsetWidth,
                l = n[0].offsetHeight;
            if (s) {
                var c = this.$element.parent(),
                    d = i,
                    u = document.documentElement.scrollTop || document.body.scrollTop,
                    p = "body" == this.options.container ? window.innerWidth : c.outerWidth(),
                    h = "body" == this.options.container ? window.innerHeight : c.outerHeight(),
                    f = "body" == this.options.container ? 0 : c.offset().left;
                i = "bottom" == i && r.top + r.height + l - u > h ? "top" : "top" == i && r.top - u - l < 0 ? "bottom" : "right" == i && r.right + a > p ? "left" : "left" == i && r.left - a < f ? "right" : i, n.removeClass(d).addClass(i)
            }
            var g = this.getCalculatedOffset(i, r, a, l);
            this.applyPlacement(g, i), this.$element.trigger("shown.bs." + this.type)
        }
    }, e.prototype.applyPlacement = function(t, e) {
        var n, i = this.tip(),
            o = i[0].offsetWidth,
            s = i[0].offsetHeight,
            r = parseInt(i.css("margin-top"), 10),
            a = parseInt(i.css("margin-left"), 10);
        isNaN(r) && (r = 0), isNaN(a) && (a = 0), t.top = t.top + r, t.left = t.left + a, i.offset(t).addClass("in");
        var l = i[0].offsetWidth,
            c = i[0].offsetHeight;
        if ("top" == e && c != s && (n = !0, t.top = t.top + s - c), /bottom|top/.test(e)) {
            var d = 0;
            t.left < 0 && (d = -2 * t.left, t.left = 0, i.offset(t), l = i[0].offsetWidth, c = i[0].offsetHeight), this.replaceArrow(d - o + l, l, "left")
        } else this.replaceArrow(c - s, c, "top");
        n && i.offset(t)
    }, e.prototype.replaceArrow = function(t, e, n) {
        this.arrow().css(n, t ? 50 * (1 - t / e) + "%" : "")
    }, e.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle();
        t.find(".tooltip-inner")[this.options.html ? "html" : "text"](e), t.removeClass("fade in top bottom left right")
    }, e.prototype.hide = function() {
        function e() {
            "in" != n.hoverState && i.detach()
        }
        var n = this,
            i = this.tip(),
            o = t.Event("hide.bs." + this.type);
        return this.$element.trigger(o), o.isDefaultPrevented() ? void 0 : (i.removeClass("in"), t.support.transition && this.$tip.hasClass("fade") ? i.one(t.support.transition.end, e).emulateTransitionEnd(150) : e(), this.$element.trigger("hidden.bs." + this.type), this)
    }, e.prototype.fixTitle = function() {
        var t = this.$element;
        (t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "")
    }, e.prototype.hasContent = function() {
        return this.getTitle()
    }, e.prototype.getPosition = function() {
        var e = this.$element[0];
        return t.extend({}, "function" == typeof e.getBoundingClientRect ? e.getBoundingClientRect() : {
            width: e.offsetWidth,
            height: e.offsetHeight
        }, this.$element.offset())
    }, e.prototype.getCalculatedOffset = function(t, e, n, i) {
        return "bottom" == t ? {
            top: e.top + e.height,
            left: e.left + e.width / 2 - n / 2
        } : "top" == t ? {
            top: e.top - i,
            left: e.left + e.width / 2 - n / 2
        } : "left" == t ? {
            top: e.top + e.height / 2 - i / 2,
            left: e.left - n
        } : {
            top: e.top + e.height / 2 - i / 2,
            left: e.left + e.width
        }
    }, e.prototype.getTitle = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title)
    }, e.prototype.tip = function() {
        return this.$tip = this.$tip || t(this.options.template)
    }, e.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }, e.prototype.validate = function() {
        this.$element[0].parentNode || (this.hide(), this.$element = null, this.options = null)
    }, e.prototype.enable = function() {
        this.enabled = !0
    }, e.prototype.disable = function() {
        this.enabled = !1
    }, e.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled
    }, e.prototype.toggle = function(e) {
        var n = e ? t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type) : this;
        n.tip().hasClass("in") ? n.leave(n) : n.enter(n)
    }, e.prototype.destroy = function() {
        this.hide().$element.off("." + this.type).removeData("bs." + this.type)
    };
    var n = t.fn.tooltip;
    t.fn.tooltip = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.tooltip"),
                s = "object" == typeof n && n;
            o || i.data("bs.tooltip", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.tooltip.Constructor = e, t.fn.tooltip.noConflict = function() {
        return t.fn.tooltip = n, this
    }
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(t, e) {
        this.init("popover", t, e)
    };
    if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
    e.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    }), e.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype), e.prototype.constructor = e, e.prototype.getDefaults = function() {
        return e.DEFAULTS
    }, e.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle(),
            n = this.getContent();
        t.find(".popover-title")[this.options.html ? "html" : "text"](e), t.find(".popover-content")[this.options.html ? "html" : "text"](n), t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide()
    }, e.prototype.hasContent = function() {
        return this.getTitle() || this.getContent()
    }, e.prototype.getContent = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
    }, e.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow")
    }, e.prototype.tip = function() {
        return this.$tip || (this.$tip = t(this.options.template)), this.$tip
    };
    var n = t.fn.popover;
    t.fn.popover = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.popover"),
                s = "object" == typeof n && n;
            o || i.data("bs.popover", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.popover.Constructor = e, t.fn.popover.noConflict = function() {
        return t.fn.popover = n, this
    }
}(window.jQuery),
function(t) {
    "use strict";

    function e(n, i) {
        var o, s = t.proxy(this.process, this);
        this.$element = t(t(n).is("body") ? window : n), this.$body = t("body"), this.$scrollElement = this.$element.on("scroll.bs.scroll-spy.data-api", s), this.options = t.extend({}, e.DEFAULTS, i), this.selector = (this.options.target || (o = t(n).attr("href")) && o.replace(/.*(?=#[^\s]+$)/, "") || "") + " .nav li > a", this.offsets = t([]), this.targets = t([]), this.activeTarget = null, this.refresh(), this.process()
    }
    e.DEFAULTS = {
        offset: 10
    }, e.prototype.refresh = function() {
        var e = this.$element[0] == window ? "offset" : "position";
        this.offsets = t([]), this.targets = t([]);
        var n = this;
        this.$body.find(this.selector).map(function() {
            var i = t(this),
                o = i.data("target") || i.attr("href"),
                s = /^#\w/.test(o) && t(o);
            return s && s.length && [
                [s[e]().top + (!t.isWindow(n.$scrollElement.get(0)) && n.$scrollElement.scrollTop()), o]
            ] || null
        }).sort(function(t, e) {
            return t[0] - e[0]
        }).each(function() {
            n.offsets.push(this[0]), n.targets.push(this[1])
        })
    }, e.prototype.process = function() {
        var t, e = this.$scrollElement.scrollTop() + this.options.offset,
            n = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight,
            i = n - this.$scrollElement.height(),
            o = this.offsets,
            s = this.targets,
            r = this.activeTarget;
        if (e >= i) return r != (t = s.last()[0]) && this.activate(t);
        for (t = o.length; t--;) r != s[t] && e >= o[t] && (!o[t + 1] || e <= o[t + 1]) && this.activate(s[t])
    }, e.prototype.activate = function(e) {
        this.activeTarget = e, t(this.selector).parents(".active").removeClass("active");
        var n = this.selector + '[data-target="' + e + '"],' + this.selector + '[href="' + e + '"]',
            i = t(n).parents("li").addClass("active");
        i.parent(".dropdown-menu").length && (i = i.closest("li.dropdown").addClass("active")), i.trigger("activate")
    };
    var n = t.fn.scrollspy;
    t.fn.scrollspy = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.scrollspy"),
                s = "object" == typeof n && n;
            o || i.data("bs.scrollspy", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.scrollspy.Constructor = e, t.fn.scrollspy.noConflict = function() {
        return t.fn.scrollspy = n, this
    }, t(window).on("load", function() {
        t('[data-spy="scroll"]').each(function() {
            var e = t(this);
            e.scrollspy(e.data())
        })
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e) {
        this.element = t(e)
    };
    e.prototype.show = function() {
        var e = this.element,
            n = e.closest("ul:not(.dropdown-menu)"),
            i = e.attr("data-target");
        if (i || (i = e.attr("href"), i = i && i.replace(/.*(?=#[^\s]*$)/, "")), !e.parent("li").hasClass("active")) {
            var o = n.find(".active:last a")[0],
                s = t.Event("show.bs.tab", {
                    relatedTarget: o
                });
            if (e.trigger(s), !s.isDefaultPrevented()) {
                var r = t(i);
                this.activate(e.parent("li"), n), this.activate(r, r.parent(), function() {
                    e.trigger({
                        type: "shown.bs.tab",
                        relatedTarget: o
                    })
                })
            }
        }
    }, e.prototype.activate = function(e, n, i) {
        function o() {
            s.removeClass("active").find("> .dropdown-menu > .active").removeClass("active"), e.addClass("active"), r ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu") && e.closest("li.dropdown").addClass("active"), i && i()
        }
        var s = n.find("> .active"),
            r = i && t.support.transition && s.hasClass("fade");
        r ? s.one(t.support.transition.end, o).emulateTransitionEnd(150) : o(), s.removeClass("in")
    };
    var n = t.fn.tab;
    t.fn.tab = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.tab");
            o || i.data("bs.tab", o = new e(this)), "string" == typeof n && o[n]()
        })
    }, t.fn.tab.Constructor = e, t.fn.tab.noConflict = function() {
        return t.fn.tab = n, this
    }, t(document).on("click.bs.tab.data-api", '[data-toggle="tab"], [data-toggle="pill"]', function(e) {
        e.preventDefault(), t(this).tab("show")
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.options = t.extend({}, e.DEFAULTS, i), this.$window = t(window).on("scroll.bs.affix.data-api", t.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", t.proxy(this.checkPositionWithEventLoop, this)), this.$element = t(n), this.affixed = this.unpin = null, this.checkPosition()
    };
    e.RESET = "affix affix-top affix-bottom", e.DEFAULTS = {
        offset: 0
    }, e.prototype.checkPositionWithEventLoop = function() {
        setTimeout(t.proxy(this.checkPosition, this), 1)
    }, e.prototype.checkPosition = function() {
        if (this.$element.is(":visible")) {
            var n = t(document).height(),
                i = this.$window.scrollTop(),
                o = this.$element.offset(),
                s = this.options.offset,
                r = s.top,
                a = s.bottom;
            "object" != typeof s && (a = r = s), "function" == typeof r && (r = s.top()), "function" == typeof a && (a = s.bottom());
            var l = !(null != this.unpin && i + this.unpin <= o.top) && (null != a && o.top + this.$element.height() >= n - a ? "bottom" : null != r && r >= i && "top");
            this.affixed !== l && (this.unpin && this.$element.css("top", ""), this.affixed = l, this.unpin = "bottom" == l ? o.top - i : null, this.$element.removeClass(e.RESET).addClass("affix" + (l ? "-" + l : "")), "bottom" == l && this.$element.offset({
                top: document.body.offsetHeight - a - this.$element.height()
            }))
        }
    };
    var n = t.fn.affix;
    t.fn.affix = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.affix"),
                s = "object" == typeof n && n;
            o || i.data("bs.affix", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.affix.Constructor = e, t.fn.affix.noConflict = function() {
        return t.fn.affix = n, this
    }, t(window).on("load", function() {
        t('[data-spy="affix"]').each(function() {
            var e = t(this),
                n = e.data();
            n.offset = n.offset || {}, n.offsetBottom && (n.offset.bottom = n.offsetBottom), n.offsetTop && (n.offset.top = n.offsetTop), e.affix(n)
        })
    })
}(window.jQuery),
function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof module && module.exports ? module.exports = function(e, n) {
        return void 0 === n && (n = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), t(n), n
    } : t(jQuery)
}

$(".box-filter input[type='radio']").on("click", function(e) {
    $("input[name='" + $(this).attr("name") + "']:radio").not(this).removeData("chk");
    $(this).data("chk", !$(this).data("chk"));
    $(this).prop("checked", $(this).data("chk"))
});
$(".apply-filter").click(function() {
    var col = $(".box-filter").data("collection");
    var url_search = "/collections/" + col + "/";
    if ($("#cat_item_1").find("input:checked").val()) url_search += $("#cat_item_1").find("input:checked").val() + "+";
    if ($("#cat_item_2").find("input:checked").val()) url_search += $("#cat_item_2").find("input:checked").val() + "+";
    if ($("#cat_item_3").find("input:checked").val()) url_search += $("#cat_item_3").find("input:checked").val() + "+";
    if ($("#cat_item_4").find("input:checked").val()) url_search += $("#cat_item_4").find("input:checked").val() + "+";
    if ($("#cat_item_5").find("input:checked").val()) url_search += $("#cat_item_5").find("input:checked").val() + "+";
    if ($("#cat_item_6").find("input:checked").val()) url_search += $("#cat_item_6").find("input:checked").val() + "+";
    if ($("#cat_item_7").find("input:checked").val()) url_search += $("#cat_item_7").find("input:checked").val() + "+";
    if ($("#cat_item_8").find("input:checked").val()) url_search += $("#cat_item_8").find("input:checked").val() + "+";
    if ($("#cat_item_9").find("input:checked").val()) url_search += $("#cat_item_9").find("input:checked").val() + "+";
    if ($("#cat_item_10").find("input:checked").val()) url_search += $("#cat_item_10").find("input:checked").val() + "+";
    if ($("#cat_item_11").find("input:checked").val()) url_search += $("#cat_item_11").find("input:checked").val() + "+";
    if ($("#cat_item_12").find("input:checked").val()) url_search += $("#cat_item_12").find("input:checked").val() + "+";
    if ($("#cat_item_13").find("input:checked").val()) url_search += $("#cat_item_13").find("input:checked").val() + "+";
    if ($("#cat_item_14").find("input:checked").val()) url_search += $("#cat_item_14").find("input:checked").val() + "+";
    if ($("#cat_item_15").find("input:checked").val()) url_search += $("#cat_item_15").find("input:checked").val() + "+";
    if ($("#cat_item_16").find("input:checked").val()) url_search += $("#cat_item_16").find("input:checked").val() + "+";
    if ($("#cat_item_17").find("input:checked").val()) url_search += $("#cat_item_17").find("input:checked").val() + "+";
    if ($("#cat_item_18").find("input:checked").val()) url_search += $("#cat_item_18").find("input:checked").val() + "+";
    if ($("#cat_item_19").find("input:checked").val()) url_search += $("#cat_item_19").find("input:checked").val() + "+";
    if ($("#cat_item_20").find("input:checked").val()) url_search += $("#cat_item_20").find("input:checked").val() + "+";
    if ($("#cat_item_21").find("input:checked").val()) url_search += $("#cat_item_21").find("input:checked").val() + "+";
    $(location).attr('href', url_search + '?view=')
});

$(".reset-filter").click(function() {
    var col = $(".box-filter").data("collection");
    var url_search = "/collections/" + col + "/";
    $(location).attr('href', url_search)
});
$(".show-more-desc a").click(function() {
    if ($(".case-desc").hasClass("show-more-height")) {
        $('.show-more-desc').addClass('relative')
    } else {
        $('.show-more-desc').removeClass('relative')
    }
    $('html, body').animate({
        scrollTop: $("#specification").offset().top
    }, 500);
    $(".case-desc").toggleClass("show-more-height")
});
$('#link-write-review').click(function() {
    $('.case-ratting').toggleClass('show-more-height2')
});
$('#link-write-questionsx').click(function() {
    $('.case-quest').toggleClass('show-more-height2')
});
$(".show-more-rat a").click(function(e) {
    e.preventDefault();
    if ($(".case-ratting").hasClass("show-more-height")) {
        $('.show-more-rat').addClass('relative');
        $('.template-product #shopify-product-reviews .spr-review').show()
    } else {
        $('.show-more-rat').removeClass('relative')
    }
    $('html, body').animate({
        scrollTop: $("#link-write-review").offset().top
    }, 500);
    $(".case-ratting").toggleClass("show-more-height")
});
$("#link-write-review").click(function() {
    $(".case-ratting").toggleClass('show-more-height');
    $('.show-more-rat').toggleClass('relative')
});
$('#product-fixed .btn').click(function() {
    $('html, body').animate({
        scrollTop: $("#product-anchor").offset().top
    }, 500)
    $('#AddToCart').trigger('click');
});
$("#fixed-product").stick_in_parent({
    offset_top: 50,
    parent: $("#product-bottom")
});
$(".form-flower #button-action .btn").click(function(e) {
    e.preventDefault();
    if ($(window).width() > 768) { /*alert("Silakan lengkapi data terlebih dahulu");*/
        $('html, body').animate({
            scrollTop: $("#product-anchor").offset().top
        }, 500);
        $("#button-action").hide()
    }
    if ($(window).width() < 769) {
        $("#flower-step").addClass("block")
    }
});
$(".customize-papan input[type='file']").change(function() {
    if ($(this).val() !== "") {
        $(this).addClass('sel');
        $(".btn-upload-papan").addClass('uploaded')
    }
});
$(".btn-upload-papan").click(function() {
    $(".customize-papan input[type='file']").click()
});
$(".add-rating-anchor").click(function() {
    $('html, body').animate({
        scrollTop: $("#anchor-review").offset().top
    }, 500)
});
$(".add-question-anchor").click(function() {
    $('html, body').animate({
        scrollTop: $("#anchor-qna").offset().top
    }, 500)
});
$("#collectionFiltersDesktop").stick_in_parent({
    offset_top: 50,
    parent: $("#collection-product")
});
$("#side-subpage").stick_in_parent({
    offset_top: 50,
    parent: $("#page-side")
});
$(document).ready(function() {
    $('.header_cart__ins a').hover(function() {
        $('header_cart__ins a img.icon_cart_active').hide()
    });
    $(".variant-button li").click(function() {
        var idx = jQuery(this).attr('data-idx');
        jQuery(".select-variant").val(idx).trigger("change")
    })
})

$(function() {
    $('.col-wrap .cats .cat').addClass('dontsplit');
    if (!$('.col-left').is('.columned')) {
        $('.col-left .cats').columnize({
            columns: 2,
            buildOnce: true
        });
        $('.col-left').addClass('columned');
    }
    
    $("select").addClass("needsclick");
    FastClick.attach(document.body);
    
    // Function to initialize select2 with retry mechanism (only on desktop >992px)
    function initAppSelect2() {
        // Only initialize select2 on desktop screens (width > 992px)
        if ($(window).width() <= 992) {
            return;
        }
        
        var $customSelects = $('.select-search');
        
        if ($customSelects.length > 0 && typeof $.fn.select2 !== 'undefined') {
            try {
                $customSelects.select2({
                    templateResult: function(result, container) {
                        if (!result.id) {
                            return result.text;
                        }
                        container.className += ' needsclick';
                        return result.text;
                    },
                    sorter: function(data) {
                        /* Sort data using lowercase comparison */
                        return data.sort(function(a, b) {
                            a = a.text.toLowerCase();
                            b = b.text.toLowerCase();
                            if (a > b) {
                                return 1;
                            } else if (a < b) {
                                return -1;
                            }
                            return 0;
                        });
                    }
                });
                $customSelects.each(function(index, el) {
                    $(el).data('select2').$container.find('*').addClass('needsclick');
                });
                console.log('App.js Select2 initialized successfully');
            } catch(e) {
                console.warn('App.js Select2 initialization failed:', e);
            }
        } else if ($customSelects.length > 0) {
            // Retry after a short delay if select2 is not yet loaded
            setTimeout(initAppSelect2, 100);
        }
    }
    
    // Initialize select2
    initAppSelect2();
});

$(document).ready(function() {
    var s = $(".header-wrapper");
    var pos = s.position();
    $(window).scroll(function() {
        var windowpos = $(window).scrollTop();
        if (windowpos > pos.top) {
            s.addClass("stick");
            $("body").addClass("header-fixed");
        } else {
            s.removeClass("stick");
            $("body").removeClass("header-fixed");
        }
    });
});
$(".lazyload").lazyload();